import ExcludedDrugs from "components/graph/ExcludedDrugs";
import SideEffectSelection from "components/graph/SideEffectSelection";
import SdmaModal from "components/SdmaModal";
import Label from "components/Label";
// import HelpButton from "components/graph/HelpButton";
import Graph from "components/graph/Graph";
import LanguageSelector from "./LanguageSelector";
import React from "react";
import AboutButton from "./AboutButton"; // Import the new component
import SmallHelpButton from "./SmallHelpButton"; // Import the new component
import { useTranslation } from "react-i18next";

export default function GraphContainer({ takenBefore = [], wouldTakeAgain = [], wouldNotTakeAgain = [], children }) {
	const { t } = useTranslation();

	return (
		<div className="element">
			<div className="header-row">
				<div className="title-container">
					<h1 className="page-title">Shared-Decision-Making Assistant (SDMA)</h1>
					<h2 className="subtitle">{t('forAdultsWithSchizophrenia')}</h2>
				</div>
				<div className="language-header">
					<LanguageSelector />
				</div>
			</div>
			<div className="graph-header">
				<SideEffectSelection />
				<div className="graph-head-buttons">
					<SmallHelpButton />
					<SdmaModal name={<Label id="graph.drug.excluded" />} buttonClass="continue-button" modalClass="help-modal">
						<ExcludedDrugs />
					</SdmaModal>
				</div>
			</div>
			<Graph takenBefore={takenBefore} wouldNotTakeAgain={wouldNotTakeAgain} wouldTakeAgain={wouldTakeAgain} />
			<div className="disclaimer">
				<Label id="app.disclaimer" />
				<AboutButton />
			</div>
		</div>
	);
}